import { render } from "./CounterROI.vue?vue&type=template&id=aa065e00&ts=true"
import script from "./CounterROI.vue?vue&type=script&lang=ts"
export * from "./CounterROI.vue?vue&type=script&lang=ts"

import "./CounterROI.vue?vue&type=style&index=0&id=aa065e00&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__